import * as types from './_actionTypes';

const initialState = {
  stats: {
    totalStudents: 0,
    activeStudents: 0,
    completedCourses: 0,
    certificatesIssued: 0,
    averageScore: 0
  },
  recentActivities: [],
  analytics: {},
  loading: false,
  error: null
};

const collegeDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_COLLEGE_DASHBOARD_REQUEST:
    case types.FETCH_COLLEGE_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_COLLEGE_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
        error: null
      };
    
    case types.FETCH_COLLEGE_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        analytics: action.payload,
        error: null
      };
    
    case types.FETCH_COLLEGE_DASHBOARD_FAILURE:
    case types.FETCH_COLLEGE_ANALYTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default collegeDashboardReducer;